const assetList = document.querySelectorAll<HTMLElement>('[data-asset-list-item]');

if(assetList) {
    assetList.forEach(asset => {
        const image = asset.querySelector<HTMLElement>('img');
        const video = asset.querySelector<HTMLVideoElement>('video');
        
        if(image && video) {
            image.addEventListener('mouseenter', () => {
                video.style.zIndex= '0';
            });

            video.addEventListener('mouseenter', () => {
                console.log('hovering');
                
                const isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;

                if (!isPlaying) {
                    video.play();
                }

            });

            video.addEventListener('mouseleave', () => {
                video.pause();
            });
        }
    });
    
}
